<template>
  <div>
    <FormulateInput
      v-slot="{ index }"
      v-model="taxes"
      name="taxes"
      type="group"
      error-behavior="live"
      :repeatable="true"
      :add-label="$t('Adicionar configuração')"
      :limit="isStockLosses ? invoiceStockLossesReasonOptions().length : 1"
    >
      <b-row>
        <b-col
          v-if="isStockLosses"
          md="6"
        >
          <FormulateInput
            :id="`tax-loss-reason-${index}`"
            name="stockLossesReason"
            type="vue-select"
            :options="invoiceStockLossesReasonOptions()"
            :label="$t('Motivo baixa de estoque')"
            :title="$t('Selecione')"
            :validation="isStockLosses ? 'required' : ''"
            :class="{ required: isStockLosses }"
            :clearable="false"
            size="5"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-st-ipi-${index}`"
            name="stIpi"
            type="vue-select"
            :label="$t('Cst Ipi Saída')"
            :placeholder="$t('Selecione')"
            :options="getComboCstIpiOutput"
            class="required"
            validation="required"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-ipi-percent-${index}`"
            name="ipiPercent"
            type="text-percetage"
            validation="required|number|min:0"
            :label="$t('Alíquota Ipi')"
            class="required"
            currency="%"
            :precision="4"
          />
        </b-col>

        <b-col md="4">
          <FormulateInput
            :id="`tax-st-pis-${index}`"
            name="stPis"
            type="vue-select"
            :label="$t('Cst Pis Saída')"
            :placeholder="$t('Selecione')"
            :options="getComboCstPisCofinsOutput"
            class="required"
            validation="required"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-pis-percent-${index}`"
            name="pisPercent"
            type="text-percetage"
            validation="required|number"
            :label="$t('Alíquota Pis')"
            class="required"
            currency="%"
            :precision="4"
          />
        </b-col>

        <b-col md="4">
          <FormulateInput
            :id="`tax-st-cofins-${index}`"
            name="stCofins"
            type="vue-select"
            :label="$t('Cst Cofins Saída')"
            :placeholder="$t('Selecione')"
            :options="getComboCstPisCofinsOutput"
            class="required"
            validation="required"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-cofins-percent-${index}`"
            name="cofinsPercent"
            type="text-percetage"
            validation="required|number|min:0"
            :label="$t('Alíquota Cofins')"
            class="required"
            currency="%"
            :precision="4"
          />
        </b-col>
        <b-col md="3">
          <FormulateInput
            :id="`tax-st-icms-${index}`"
            name="stIcms"
            type="vue-select"
            :label="$t('Cst Icms')"
            :placeholder="$t('Selecione')"
            :options="getComboCstIcms"
            class="required"
            validation="required"
          />
        </b-col>
        <b-col md="6">
          <FormulateInput
            :id="`tax-icms-csosn-${index}`"
            name="csosnIcms"
            type="vue-select"
            :label="$t('Csosn Icms')"
            :placeholder="$t('Selecione')"
            :options="getComboCsosnIcms"
          />
        </b-col>

        <b-col md="2">
          <FormulateInput
            :id="`tax-icms-percent-${index}`"
            name="icmsPercent"
            type="text-percetage"
            validation="required|number|min:0"
            currency="%"
            :precision="4"
            :label="$t('Alíquota Icms')"
            class="required"
          />
        </b-col>

        <b-col md="2">
          <FormulateInput
            :id="`tax-icmsBaseReduction-percent-${index}`"
            name="icmsBaseReductionPercent"
            type="text-percetage"
            :label="$t('Redução Base Icms')"
            validation="required|number|min:0"
            currency="%"
            :precision="4"
            class="required"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-icms-iva-${index}`"
            name="iva"
            type="text-percetage"
            :label="$t('Iva')"
            class="required"
            validation="required|number|min:0"
            currency="%"
            :precision="4"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-icms-st-percent-${index}`"
            name="icmsStPercent"
            type="text-percetage"
            :label="$t('Alíquota Icms ST')"
            class="required"
            validation="required|number|min:0"
            currency="%"
            :precision="4"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-icms-st-base-reduction-percent-${index}`"
            name="icmsStBaseReductionPercent"
            type="text-percetage"
            :label="$t('Redução Base Icms ST')"
            class="required"
            validation="required|number|min:0"
            currency="%"
            :precision="4"
          />
        </b-col>

        <b-col md="3">
          <FormulateInput
            :id="`tax-icms-fcp-percent-${index}`"
            name="fcpPercent"
            type="text-percetage"
            :label="$t('Alíquota Fundo de Combate à Pobreza')"
            validation="required|number|min:0"
            class="required"
            currency="%"
            :precision="4"
          />
        </b-col>

        <b-col md="3">
          <FormulateInput
            :id="`tax-icms-fcp-st-percent-${index}`"
            name="fcpStPercent"
            type="text-percetage"
            :label="$t('Alíquota Fundo de Combate à Pobreza ST')"
            validation="required|number|min:0"
            class="required"
            currency="%"
            :precision="4"
          />
        </b-col>
      </b-row>

      <!-- Tax Reform (CBS/IBS) Fields -->
      <hr class="my-2">
      <h6 class="mb-1">
        {{ $t('Informações Gerais') }}
      </h6>
      <b-row>
        <b-col md="4">
          <FormulateInput
            :id="`tax-st-cbs-ibs-${index}`"
            name="stCbsIbsCode"
            type="vue-select"
            :options="comboCstCbsIbs"
            :placeholder="$t('Selecione')"
            :label="$t('Situação Trib. CBS/IBS')"
          />
        </b-col>
        <b-col md="8">
          <FormulateInput
            :id="`tax-fiscal-classification-cbs-ibs-${index}`"
            name="fiscalClassificationCbsIbsCode"
            type="vue-select"
            :placeholder="$t('Selecione')"
            :disabled="!getTaxStCbsIbsCode(index)"
            :options="getComboFiscalClassification(getTaxStCbsIbsCode(index))"
            :label="$t('Classificação CBS/IBS')"
          />
        </b-col>
      </b-row>

      <h6 class="mb-1 mt-1">
        {{ $t('CBS') }}
      </h6>
      <b-row>
        <b-col md="4">
          <FormulateInput
            :id="`tax-cbs-percent-${index}`"
            name="cbsPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Alíquota CBS (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-cbs-reduction-percent-${index}`"
            name="cbsReductionPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Redução CBS (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-cbs-deferral-percent-${index}`"
            name="cbsDeferralPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Diferimento CBS (%)')"
          />
        </b-col>
      </b-row>

      <h6 class="mb-1 mt-1">
        {{ $t('IBS') }}
      </h6>
      <p class="mb-1">
        {{ $t('IBS Estadual') }}
      </p>
      <b-row>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-state-percent-${index}`"
            name="ibsStatePercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Alíquota IBS Estado (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-state-reduction-percent-${index}`"
            name="ibsStateReductionPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Redução IBS Estado (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-state-deferral-percent-${index}`"
            name="ibsStateDeferralPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Diferimento IBS Estado (%)')"
          />
        </b-col>
      </b-row>

      <p class="mb-1 mt-1">
        {{ $t('IBS Municipal') }}
      </p>
      <b-row>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-municipal-percent-${index}`"
            name="ibsMunicipalPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Alíquota IBS Município (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-municipal-reduction-percent-${index}`"
            name="ibsMunicipalReductionPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Redução IBS Município (%)')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            :id="`tax-ibs-municipal-deferral-percent-${index}`"
            name="ibsMunicipalDeferralPercent"
            type="text-percetage"
            currency="%"
            :precision="5"
            :label="$t('Diferimento IBS Município (%)')"
          />
        </b-col>
      </b-row>

      <!-- Selective Tax Fields -->
      <hr class="my-2">
      <h6 class="mb-1">
        {{ $t('Imposto Seletivo') }}
      </h6>
      <b-row>
        <b-col md="3">
          <FormulateInput
            :id="`tax-selective-tax-st-${index}`"
            name="stSelectiveTaxCode"
            type="vue-select"
            :options="comboCstCbsIbs"
            :placeholder="$t('Selecione')"
            :label="$t('Situação Trib. Imposto Seletivo')"
          />
        </b-col>
        <b-col md="3">
          <FormulateInput
            :id="`tax-selective-tax-classification-${index}`"
            name="fiscalClassificationSelectiveTaxCode"
            type="vue-select"
            :placeholder="$t('Selecione')"
            :disabled="!getTaxStSelectiveTaxCode(index)"
            :options="getComboSelectiveClassification(getTaxStSelectiveTaxCode(index))"
            :label="$t('Classificação Imposto Seletivo')"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-selective-tax-type-${index}`"
            name="selectiveTaxType"
            type="vue-select"
            :options="comboSelectiveTaxTypes"
            :placeholder="$t('Selecione')"
            :label="$t('Tipo Imposto Seletivo')"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-selective-tax-percent-${index}`"
            name="selectiveTaxPercent"
            type="text-percetage"
            currency="%"
            :precision="4"
            :label="$t('% Imposto Seletivo')"
          />
        </b-col>
        <b-col md="2">
          <FormulateInput
            :id="`tax-selective-tax-value-per-unit-${index}`"
            name="selectiveTaxValuePerUnit"
            type="text-percetage"
            currency="R$"
            :precision="4"
            :label="$t('Valor por Unidade')"
          />
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="12">
          <FormulateInput
            v-slot="{ index: benefitCodeIndex }"
            name="benefitCodes"
            type="group"
            :repeatable="true"
            :add-label="$t('Adicionar cBenef por UF')"
            :label="$t('Código do Benefício Fiscal (cBenef)')"
            :instruction="
              $t(
                'Código do benefício fiscal usado nos itens da nota quando esse CFOP for escolhido como natureza da operação. É usado o código da UF da loja emitente, ou seja, quando a UF não tiver um código informado o campo fica em branco na nota.'
              )
            "
          >
            <b-row>
              <b-col md="3">
                <FormulateInput
                  :id="`tax-benefit-code-province-${index}-${benefitCodeIndex}`"
                  name="province"
                  type="vue-select"
                  :options="comboProvinces"
                  :placeholder="$t('Selecione')"
                  :label="$t('UF')"
                  class="required"
                  validation="required"
                  :clearable="false"
                />
              </b-col>
              <b-col md="3">
                <FormulateInput
                  :id="`tax-benefit-code-${index}-${benefitCodeIndex}`"
                  name="code"
                  type="text"
                  :label="$t('cBenef')"
                  class="required"
                  validation="required"
                />
              </b-col>
            </b-row>
          </FormulateInput>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col md="12">
          <FormulateInput
            v-slot="{ index: additionalInformationIndex }"
            name="additionalInformation"
            type="group"
            :repeatable="true"
            :add-label="$t('Adicionar texto por UF')"
            :label="$t('Dados adicionais da nota')"
            :instruction="
              $t(
                'Texto preenchido automaticamente nas informações adicionais da nota quando esse CFOP for escolhido como natureza da operação. É usado o texto da UF da loja emitente e, quando ela não tiver um texto próprio, o texto padrão. Na nota o texto continua editável.'
              )
            "
          >
            <b-row>
              <b-col md="3">
                <FormulateInput
                  :id="`tax-additional-information-province-${index}-${additionalInformationIndex}`"
                  name="province"
                  type="vue-select"
                  :options="comboAdditionalInformationProvinces"
                  :placeholder="$t('Selecione')"
                  :label="$t('UF')"
                  class="required"
                  validation="required"
                  :clearable="false"
                />
              </b-col>
              <b-col md="9">
                <FormulateInput
                  :id="`tax-additional-information-text-${index}-${additionalInformationIndex}`"
                  name="text"
                  type="textarea"
                  :label="$t('Texto')"
                  class="required"
                  validation="required"
                />
              </b-col>
            </b-row>
          </FormulateInput>
        </b-col>
      </b-row>
    </FormulateInput>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { invoiceDomains, province } from '@/mixins'

export default {
  name: 'CfopCustomTaxesForm',
  components: { BCol, BRow },
  mixins: [invoiceDomains, province],
  props: {
    isStockLosses: {
      type: Boolean,
      default: false,
    },
    taxes: {
      type: Array,
      default: null,
    },
  },

  computed: {
    ...mapGetters('pages/invoice/taxClassifications', [
      'getCstIcms',
      'getCsosnIcms',
      'getComboCstPisCofinsOutput',
      'getComboCstIpiOutput',
    ]),
    ...mapGetters('pages/invoice/fiscalTaxParameters', ['getCstCbsIbs', 'getClassTribsByCst', 'getSelectiveTaxTypes']),

    // cBenef não possui valor default: o código é aplicado apenas na UF informada
    comboProvinces() {
      return this.provinces().map(item => ({
        value: item.value,
        label: `${item.value} - ${item.label}`,
      }))
    },
    comboAdditionalInformationProvinces() {
      return [{ value: 'DEFAULT', label: this.$t('Padrão (demais UFs)') }, ...this.comboProvinces]
    },
    getComboCstIcms() {
      return this.getCstIcms.map(c => ({
        label: `${c.code} - ${c.description}`,
        value: c.code,
      }))
    },
    getComboCsosnIcms() {
      return this.getCsosnIcms.map(c => ({
        label: `${c.code} - ${c.description}`,
        value: c.code,
      }))
    },
    comboCstCbsIbs() {
      return this.getCstCbsIbs.map(c => ({
        value: c.code,
        label: `${c.code} - ${c.description}`,
      }))
    },
    comboSelectiveTaxTypes() {
      return this.getSelectiveTaxTypes.map(c => ({
        value: c.value,
        label: c.label,
      }))
    },
  },

  watch: {
    taxes: {
      handler(newTaxes) {
        if (!newTaxes) return
        newTaxes.forEach(tax => {
          if (tax?.stCbsIbsCode) {
            this.fetchClassTribsByCst(tax.stCbsIbsCode)
          }
          if (tax?.stSelectiveTaxCode) {
            this.fetchClassTribsByCst(tax.stSelectiveTaxCode)
          }
        })
      },
      deep: true,
      immediate: true,
    },
  },

  async mounted() {
    await this.fetchCombos()
  },

  methods: {
    ...mapActions('pages/invoice/fiscalTaxParameters', ['fetchCombos', 'fetchClassTribsByCst']),

    getTaxStCbsIbsCode(index) {
      return this.taxes && this.taxes[index] ? this.taxes[index].stCbsIbsCode : null
    },

    getTaxStSelectiveTaxCode(index) {
      return this.taxes && this.taxes[index] ? this.taxes[index].stSelectiveTaxCode : null
    },

    getComboFiscalClassification(cstCode) {
      if (!cstCode) return []
      const items = this.getClassTribsByCst(cstCode)
      return items.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },

    getComboSelectiveClassification(cstCode) {
      if (!cstCode) return []
      const items = this.getClassTribsByCst(cstCode)
      return items.map(c => ({ value: c.code, label: `${c.code} - ${c.description}` }))
    },
  },
}
</script>

<style></style>
